var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import './suep-card.css';
import { ReactComponent as PaperNote } from '../../assets/images/global/papernote-eye.svg';
import { ReactComponent as ReportCheck } from '../../assets/images/global/report-check.svg';
import { ReactComponent as Gain } from '../../assets/images/global/movement-up.svg';
import { ReactComponent as Loss } from '../../assets/images/global/movement-down.svg';
import { ReactComponent as Time } from '../../assets/images/global/reportPendingRelease.svg';
import { SuepCardAPI } from '.';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let SuepCard = class SuepCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, clinicalNoteId, description, eStatus, evolution, title, subtitle } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        clinicalNoteId,
                        description,
                        eStatus,
                        evolution,
                        onClick,
                        subtitle,
                        title
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIcon(type) {
        switch (type) {
            case 'EV':
                return React.createElement(PaperNote, null);
            case 'P':
                return React.createElement(Loss, null);
            case 'G':
                return React.createElement(Gain, null);
            default:
                if (!this.props.isReleased) {
                    return React.createElement(Time, null);
                }
                return React.createElement(ReportCheck, null);
        }
    }
    renderBadgeColor(outOfRange) {
        const valueOutOfRange = 'S';
        const badgeColor = outOfRange === valueOutOfRange ? 'red' : 'green';
        return `c-suep-card-content-vital-badge-${badgeColor}`;
    }
    renderLegend(type) {
        let legends = [];
        if (type) {
            switch (type) {
                case 'P':
                case 'G':
                    legends = [
                        {
                            color: 'signal-gray-60',
                            icon: React.createElement(Gain, null),
                            label: MessageService.translate('tws.label-intake'),
                            value: MessageService.translate('tws.label-intake'),
                        },
                        {
                            color: 'signal-gray-60',
                            icon: React.createElement(Loss, null),
                            label: MessageService.translate('tws.label-output'),
                            value: MessageService.translate('tws.label-output')
                        }
                    ];
                    break;
                default:
                    legends = [
                        {
                            color: 'signal-green-45',
                            label: MessageService.translate('description-exam-status.exam-within-the-value'),
                            value: MessageService.translate('description-exam-status.exam-within-the-value')
                        },
                        {
                            color: 'signal-red-45',
                            label: MessageService.translate('message.value-out-of-reference'),
                            value: MessageService.translate('message.value-out-of-reference')
                        },
                    ];
                    break;
            }
        }
        return legends;
    }
    renderData() {
        const { description, informationValue, outOfRange, subtitle, type, title, } = this.props;
        return (React.createElement(React.Fragment, null,
            type &&
                React.createElement("div", { className: 'c-suep-card-content-item', onClick: () => this.handleClick() },
                    React.createElement("div", { className: 'c-suep-card' },
                        React.createElement(Text, { className: "c-title-value", value: description }),
                        title &&
                            React.createElement(Text, { className: "c-text-value", value: title }),
                        React.createElement(Text, { className: "c-text-value", value: subtitle })),
                    React.createElement("div", { className: 'c-suep-card-content' },
                        type === 'ST' && (React.createElement("div", { className: `c-suep-card-content-vital-badge ${this.renderBadgeColor(outOfRange)}` },
                            React.createElement(Text, { className: "c-text-value-text", value: String(informationValue) }))),
                        type !== 'ST' && (React.createElement("div", { className: 'suep-icon' }, this.renderIcon(type))))),
            !type &&
                React.createElement("div", { className: 'c-suep-card-content-item', onClick: () => this.handleClick() },
                    React.createElement("div", { className: 'c-suep-card' },
                        React.createElement(Text, { className: "c-title-value", value: description }),
                        title &&
                            React.createElement(Text, { className: "c-text-value", value: title }),
                        React.createElement(Text, { className: "c-text-value", value: subtitle })))));
    }
    render() {
        const { clinicalNoteId, type } = this.props;
        return (React.createElement(Card, { className: 'c-suep-card-main c-hidden-tap', uuid: generateUUID(), width: 12, key: clinicalNoteId, selectionType: SelectionType.SINGLE, superscription: this.renderLegend(type) },
            React.createElement("div", { className: 'c-suep-card__wrapper' }, this.renderData())));
    }
};
SuepCard = __decorate([
    AwesomeComponent({ api: SuepCardAPI, type: ComponentType.DATA_DISPLAY })
], SuepCard);
export default SuepCard;
//# sourceMappingURL=suep-card.js.map